module.exports = __webpack_public_path__ + "img/no-questionnaire.cc1f6478.png";